import styled, { keyframes } from "styled-components";

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  & > div {
    margin-bottom: 0;
    margin-left: 8px;
  }
`;

export const GroupLabel = styled.legend`
  margin-bottom: 0;
  padding-left: 0px;
  font-weight: bold;
  font-size: 1rem;
  color: ${(p) => (p.error ? p.theme.colors[p.error] : p.theme.colors.primary)};
`;

const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(
        result[3],
        16
      )}`
    : null;
};

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  cursor: ${(p) => (p.disabled ? "default" : "pointer")};
  padding: 18px;
  margin-bottom: 6px;

  &:hover,
  &.focusEffect {
    background-color: ${(p) =>
      p.disabled
        ? "inherit"
        : hexToRgb(p.theme.colors.primary)
        ? `rgba(${hexToRgb(p.theme.colors.primary)}, 0.6)`
        : "rgba(0, 0, 0, 0.6)"};
  }
`;

export const Box = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background-color: ${(p) =>
    p.disabled && p.checked
      ? "#888"
      : p.checked
      ? p.theme.colors.primary
      : "#fff"};
  border: 2px solid
    ${(p) =>
      p.disabled
        ? "#888"
        : p.error
        ? p.theme.colors[p.error]
        : p.theme.colors.primary};
  border-radius: 50%;
  z-index: 1;
`;

export const Check = styled.div`
  width: ${(p) => (p.checked ? "10px" : "0")};
  height: ${(p) => (p.checked ? "10px" : "0")};
  background-color: ${(p) => (p.checked ? p.theme.colors.primary : "#fff")};
  border-radius: 50%;
  transition: all 100ms;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

const clickEffect = keyframes`
  0% {
    width: 20px;
    height: 20px;
    opacity: 0;
    box-shadow: 0 0 5px inset rgba(0, 0, 0, 0);
  }
  40% {
    width: 100%;
    height: 100%;
    opacity: 0.2;
    box-shadow: 0 0 15px inset rgba(0, 0, 0, 0.2);
  }
  100% {
    width: 100%;
    height: 100%;
    opacity: 0;
    box-shadow: 0 0 15px inset rgba(0, 0, 0, 0);
  }
`;

export const Shadow = styled.div`
  width: ${(p) => (!p.focus ? "10px" : "100%")};
  height: ${(p) => (!p.focus ? "10px" : "100%")};
  background-color: ${(p) => p.theme.colors.primary};
  border-radius: 50%;
  opacity: ${(p) => (!p.focus ? 0 : 0.2)};

  @media (prefers-reduced-motion: no-preference) {
    &.animate {
      animation: ${clickEffect} 0.4s linear;
    }
  }
`;
export const Input = styled.input`
  position: absolute;
  z-index: -1;
  opacity: 0;

  &:focus {
    outline: none;
  }
`;

export const Label = styled.label`
  padding-left: 5px;
  margin-bottom: 0;
  color: ${(p) =>
    p.disabled ? "#888" : p.error ? p.theme.colors[p.error] : "inherit"};
  cursor: ${(p) => (p.disabled ? "default" : "pointer")};
`;

export const BaseButton = styled.button`
  padding: 12px;
  border: none;
  margin-bottom: 4px;
  color: white;
  min-width: 80px;
  opacity: ${(p) => (p.disabled ? "0.5" : "1")};
  background-color: ${(p) => (p.selected ? "#3a445b" : "#ededed")};
  color: ${(p) => (p.selected ? "#fff" : "#000")};
`;

export const BlockButton = styled(BaseButton)`
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
`;

export const RegularButton = styled(BaseButton)`
  background-color: ${(p) => (p.selected ? "#3a445b" : "#ededed")};
  border-radius: 24px;
  margin: 4px;
  color: ${(p) => (p.selected ? "#fff" : "#000")};
`;
